var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.loading
        ? _c(
            "b-row",
            { staticClass: "match-height" },
            [
              _c(
                "b-col",
                { attrs: { md: "6", lg: "4" } },
                [
                  _c(
                    "b-card",
                    {
                      class: [
                        "template-card",
                        {
                          "selected-card":
                            _vm.buttonLabel("template1") === "Configure",
                        },
                      ],
                      attrs: {
                        "img-src": require("@/assets/images/templates/t1.png"),
                        "img-alt": "Card image cap",
                        "img-top": "",
                        title: "Template 1",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectCard("template1")
                        },
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(113, 102, 240, 0.15)",
                              expression: "'rgba(113, 102, 240, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.configureTemplate("template1")
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.buttonLabel("template1")) + " "
                          ),
                        ]
                      ),
                      _vm.buttonLabel("template1") === "Configure"
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(113, 102, 240, 0.15)",
                                  expression: "'rgba(113, 102, 240, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              staticClass: "ml-2",
                              attrs: { variant: "outline-primary" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.previewTemplate()
                                },
                              },
                            },
                            [_vm._v(" Preview ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6", lg: "4" } },
                [
                  _c(
                    "b-card",
                    {
                      class: [
                        "template-card",
                        {
                          "selected-card":
                            _vm.buttonLabel("template2") === "Configure",
                        },
                      ],
                      attrs: {
                        "img-src": require("@/assets/images/templates/t2.png"),
                        "img-alt": "Card image cap",
                        "img-top": "",
                        title: "Template 2",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectCard("template2")
                        },
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(113, 102, 240, 0.15)",
                              expression: "'rgba(113, 102, 240, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.configureTemplate("template2")
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.buttonLabel("template2")) + " "
                          ),
                        ]
                      ),
                      _vm.buttonLabel("template2") === "Configure"
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(113, 102, 240, 0.15)",
                                  expression: "'rgba(113, 102, 240, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              staticClass: "ml-2",
                              attrs: { variant: "outline-primary" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.previewTemplate()
                                },
                              },
                            },
                            [_vm._v(" Preview ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6", lg: "4" } },
                [
                  _c(
                    "b-card",
                    {
                      class: [
                        "template-card",
                        {
                          "selected-card":
                            _vm.buttonLabel("template3") === "Configure",
                        },
                      ],
                      attrs: {
                        "img-src": require("@/assets/images/templates/t3.png"),
                        "img-alt": "Card image cap",
                        "img-top": "",
                        title: "Template 3",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectCard("template3")
                        },
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(113, 102, 240, 0.15)",
                              expression: "'rgba(113, 102, 240, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.configureTemplate("template3")
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.buttonLabel("template3")) + " "
                          ),
                        ]
                      ),
                      _vm.buttonLabel("template3") === "Configure"
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(113, 102, 240, 0.15)",
                                  expression: "'rgba(113, 102, 240, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              staticClass: "ml-2",
                              attrs: { variant: "outline-primary" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.previewTemplate()
                                },
                              },
                            },
                            [_vm._v(" Preview ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "loader-container" },
            [_c("b-spinner", { attrs: { label: "Loading..." } })],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }